<template>
  <div class="signup container">
    <form class="card-panel" @submit.prevent="signup">
      <h2 class="center black-text">Register</h2>
      <p class="center orange-text accent-4">
        This will site request and display current location.
      </p>
      <div class="field">
        <label for="email">Email</label>
        <input id="email" type="email" v-model="email" />
      </div>
      <div class="field">
        <label for="name">Username</label>
        <input id="name" type="text" v-model="alias" />
      </div>
      <div class="field">
        <label for="password">Password</label>
        <input id="password" type="password" v-model="password" />
      </div>
      <p v-if="feedback" class="red-text center">{{ feedback }}</p>
      <div class="field center">
        <button class="btn orange accent-4">Signup</button>
      </div>
    </form>
  </div>
</template>

<script>
import db from "@/firebase/init";
import slugify from "slugify";
import firebase from "firebase";

export default {
  name: "Signup",
  data() {
    return {
      email: null,
      password: null,
      alias: null,
      feedback: null,
      slug: null,
    };
  },
  methods: {
    signup() {
      if (this.alias && this.email && this.password) {
        this.feedback = null;
        this.slug = slugify(this.alias, {
          replacement: "-",
          remove: /[$*_+~.()'"!\-:@]/g,
          lower: true,
        });
        let ref = db.collection("users").doc(this.slug);
        ref.get().then((doc) => {
          if (doc.exists) {
            this.feedback = "This alias already exists";
          } else {
            // this alias does not yet exists in the db
            firebase
              .auth()
              .createUserWithEmailAndPassword(this.email, this.password)
              .then((user) => {
                ref.set({
                  alias: this.alias,
                  geolocation: null,
                  user_id: user.uid,
                });
              })
              .then(() => {
                this.$router.push({ name: "GMap" });
              })
              .catch((err) => {
                this.feedback = err.message;
              });
          }
        });
      } else {
        this.feedback = "Please fill in all fields";
      }
    },
  },
};
</script>

<style>
.signup {
  max-width: 500px;
  margin-top: 60px;
}
.signup h2 {
  font-size: 2.6em;
}
.signup .field {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue